export default {
  ApiUrl: process.env.API_URL
}
